/*=========================================================================================
  File Name: moduleCategoryActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	addCategory({commit}, category) {
		return new Promise((resolve, reject) => {
			Api.post("/category", category)
				.then((response) => {
					commit("ADD_CATEGORY", Object.assign(category, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// ACTIONS FOR RESORCES
	fetchCategory({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/category")
				.then((res) => {
					commit("SET_CATEGORIES", res.data.reverse());
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	fetchCategoryById({commit}, categoryId) {
		return new Promise((resolve, reject) => {
			Api.get(`/category/${categoryId}`)
				.then((res) => {
					//commit('GET_RESOURCE_BY_ID', res.data)
					resolve(res);
				})
				.catch((err) => {
					throw new Error(err);
				});
		});
	},
	updateCategory({commit}, category) {
		return new Promise((resolve, reject) => {
			Api.put(`/category/${category.id}`, category)
				.then((response) => {
					commit("UPDATE_CATEGORY", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeCategory({commit}, categoryId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/category/${categoryId}`)
				.then((response) => {
					commit("REMOVE_CATEGORY", categoryId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	getCategorySchema({commit}, category) {
		return new Promise((resolve, reject) => {
			Api.post(`/jsons/category`, category)
				.then((res) => {
					//commit('GET_RESOURCE_BY_ID', res.data)
					resolve(res);
				})
				.catch((err) => {
					throw new Error(err);
				});
		});
	},
	setDescription({commit}, data) {
		return new Promise((resolve, reject) => {
			commit("SET_DESCRIPTION", data);
			resolve(data);
		});
	},
	setName({commit}, index, name) {
		commit("SET_NAME", index, name);
	},
	addNewField({commit}, newField) {
		commit("ADD_NEW_FIELD", newField);
	},
	removeAdditionalField({commit}, field) {
		commit("REMOVE_FIELD", field);
	},
};
